import { campaign } from './../containers/hirings/new-hiring/health/health-price/health-price-dto/campaign-dto';
import GeneralServices from "./GeneralServices";

class CampaignsServices {
  getCampaigns = async (args: any) => {
    try {
      const res = await GeneralServices.get({
        loader: args.loader,
        setLoading: args.setLoading,
        endpoint: `campaigns?colective=${args.colective}&combinacion_comercial=${args.combinacion_comercial}&fecha_inicio=${args.fecha_inicio}`
      });
      return res.data;
    } catch (err) {
      throw err;
    }
  };

  getAllCampaigns = async (args: any) => {
    try {
      const res = await GeneralServices.get({
        loader: args.loader,
        setLoading: args.setLoading,
        endpoint: `campaigns/all`
      });
      return res.data;
    } catch (err) {
      throw err;
    }
  };

  getCampaignsByCode = async (args: any) => {
    try {
      const res = await GeneralServices.get({
        loader: args.loader,
        setLoading: args.setLoading,
        endpoint: `campaigns/code?code=${args.code}`
      });
      return res.data;
    } catch (err) {
      throw err;
    }
  };

  addCampaign = async (args: any): Promise<any> => {
    try {
        const response = await GeneralServices.post({
            setLoading: args.setLoading,
            isSlowProcess: true,
            loader: args.loader,
            endpoint: `campaigns`,
            data: args.campaign,
        });
        return response.data;
    } catch (err) {
        throw err;
    }
  };


  updateCampaign = async (args: any): Promise<any> => {
    try {
        const response = await GeneralServices.put({
            setLoading: args.setLoading,
            isSlowProcess: true,
            loader: args.loader,
            endpoint: `campaigns`,
            data: args.campaign,
        });
        return response.data;
    } catch (err) {
        throw err;
    }
  };

  deleteCampaignsByCode = async (args: any) => {
    try {
      const res = await GeneralServices.deleteReq({
        loader: args.loader,
        setLoading: args.setLoading,
        endpoint: `campaigns/${args.code}`
      });
      return res.data;
    } catch (err) {
      throw err;
    }
  };
  
}

export default new CampaignsServices();
